define('views/modules/calendar/animated-session/tags/manager/edit/tag-edit-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/layout',
    // models
    'models/calendar/session/tag',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/calendar/animated-session/tags/manager/edit/tag-edit-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    LayoutState,
    // models
    MTag,
    // views
    VBasePanel,
    VTagEditContent
) {

    var VTagEditPanel = VBasePanel.extend({
        header: {
            title: 'calendar:Tag Edit',
            subtitle: 'calendar:Add/Modify a custom tag',
        },
        content: {
            edit: VTagEditContent,
        },

        buttons: {
            close: 'close',
            expand: 'onExpandPanel',
        },

        tabs: [{ id: 'edit', title: 'Edit', active: true }],
        defaultView: 'edit',
        initialize: function(opt) {
            opt = opt || {};
            this.model = new MTag();
            var edit = this.getView('edit', {
                model: this.model,
                group: opt.group
            });

            this.listenTo(edit, {
                'form:success': this.onSuccess,
                'drawer:view': this.onSetDrawerView
            });
            this.listenTo(this, { 'toggle': this.onOpen });
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            this.model.fetch();
            return this;
        },

        resetModel: function(attrs, options) {
            this.model.reset(attrs, options);
            return this;
        },

        ////////////
        // events //
        ///////////

        onOpen: function(open) {
            var view = this.view;
            if (this.is(view.edit) &&
                !Viewport.isMobile() && open
            ) {
                view.edit.toggleAnimationPanel(true);
            }
        },

        onSuccess: function(model) {
            this.trigger('form:success', model);
            this.close();
        },

        // TODO: changed this with new panel full behavior
        // onExpandPanel: function() {
        //     if (LayoutState.isFull('info')) {
        //         LayoutState.toggleInfoFull();
        //     } else {
        //         this.view.edit.toggleAnimationPanel(true);
        //     }
        // },

        onClosePanel: function() {
            LayoutState.toggleInfo(false);
        },

        onSetDrawerView: function(panel, open) {
            this.trigger('drawer:view', panel, open);
        },
    });

    return VTagEditPanel;

});

